import * as Sentry from '@sentry/react'
import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import '../styles/application.css'

// Sentry frontend project — separate from the Ruby project, separate DSN.
// VITE_SENTRY_DSN is baked into the bundle at build time; missing → init
// is skipped and Sentry stays silent (dev + test).
//
// `sendDefaultPii: true` matches the Ruby-side config: warehouse is
// internal tooling, full request context makes the dashboard actually
// useful for debugging.
if (import.meta.env.PROD && import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: true,
  })
}

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob(['../pages/**/*.tsx', '!../pages/**/*.test.tsx'], { eager: true })
    const page = pages[`../pages/${name}.tsx`]
    if (!page) {
      throw new Error(`Page not found: ${name}. Make sure ../pages/${name}.tsx exists.`)
    }
    return page
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />)
  },
})
